export const environment = {
  releaseTagVersion: 'v1.7.0',
  runnerEnvironment: 'PRE',
  production: false,
  taqtEnabled: false, // TAQT_FLAG
  name: '-pre',
  serverApi: 'https://edit-surveys-pre.ratenow.es/API',
  serverBackend: 'https://edit-surveys-pre.ratenow.es/SURVEYEDITOR',
  serverIFrame: 'https://surveys-pre.ratenow.es/design',
  apiClientId: '015865ea-dcf9-47b2-b24f-86e77d7a55bf',
  apiSecretKey: 'H0DgOgffzIzbEzVLqfHXWpEzc2tUoeOfN2B0Nk6YPCn3',
  country: 'ES',
  scope: 'survey_editor',
  serverSignin: 'https://auth-pre.ratenow.es/signin',
  logIn: 'https://auth-pre.ratenow.es/signin/oauth/authorize',
  logOut: 'https://auth-pre.ratenow.es/signin/logout'
};
